export default __webpack_public_path__ + "static/media/Folder_send_light.8fd54c5c.svg";